module.exports = __webpack_public_path__ + "media/honey-icons/icon-film-quality-82434139.svg";